import { render, staticRenderFns } from "./ArtistCard.vue?vue&type=template&id=1ec6f748&scoped=true"
import script from "./ArtistCard.vue?vue&type=script&lang=js"
export * from "./ArtistCard.vue?vue&type=script&lang=js"
import style0 from "./ArtistCard.vue?vue&type=style&index=0&id=1ec6f748&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ec6f748",
  null
  
)

export default component.exports